import { CSSProperties, useCallback, useEffect, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { useTheme } from '../../../../../hooks/useTheme';

const toKebab = (key: string): string =>
  key.replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase();

const styleObjectToString = (s: CSSProperties): string =>
  Object.entries(s).reduce((accum, [key, value]: [string, string]) => {
    return `${toKebab(key)}:${value};${accum}`;
  }, '');

function useHackStyle() {
  const cssClass = 'descriptionStyleHack';
  const styleRef = useRef(uuid());
  const { linksNoneDefault: link, linksNoneHover: hover } = useTheme();

  const generateStyle = useCallback(() => {
    const linkStyle = link
      ? `.${cssClass} a { ${styleObjectToString(link)}}`
      : '';

    const linkHoverStyle = hover
      ? `.${cssClass} a:hover { ${styleObjectToString(hover)}}`
      : '';

    return [linkStyle, linkHoverStyle].join('');
  }, [link, hover]);

  useEffect(() => {
    const exisitingStyleTag = document.getElementById(styleRef.current);

    if (exisitingStyleTag) return;

    const styleTag = document.createElement('style');
    const styling = generateStyle();

    document.head.appendChild(styleTag);

    styleTag.setAttribute('id', styleRef.current);
    styleTag.appendChild(document.createTextNode(styling));
  }, [generateStyle]);

  return { cssClass };
}

export { useHackStyle };
